
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import { styled, Tooltip, useTheme } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'

import { Icon } from '../../Icon/Icon'

export type AlertGridCellProps = GridRenderCellParams & {
  //
}

export type AlertType = 'success' | 'warning' | 'error'

export type AlertGridCellValueType = {
  tooltipText?: string
  icon: IconDefinition
  type: AlertType
}

export const AlertGridCell: React.FC<AlertGridCellProps> = ({ value }) => {
  const theme = useTheme()

  const colorMapping = {
    'success': theme.palette.success.main,
    'warning': theme.palette.warning.main,
    'error': theme.palette.error.main,
  }

  return value ? (
    <Tooltip title={value.tooltipText} arrow placement="right">
      <StyledContainer>
        <StyledIcon icon={value.icon} $color={colorMapping[value.type as AlertType]} />
      </StyledContainer>
    </Tooltip>
  ) : null
}

const StyledContainer = styled('div')`
  width: 100%;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
`

const StyledIcon = styled(Icon, { shouldForwardProp: (prop) => prop !== '$color' }) <{ $color: string }>`
  color: ${props => props.$color};
  font-size: 18px;
`